module.exports = __webpack_public_path__ + "img/nguyen_thumbnail.ad17204c.jpg";